export const reduxLogger = (store) => (next) => (action) => {
  try {
    if (store.getState().app.config.reduxLogging) {
      console.groupCollapsed('Logger ', typeof action === 'function' ? action : action.type);
      console.log('%c Action:', 'color: blue', action);
      console.log('%c Previous State:', 'color: red', store.getState());
      next(action);
      console.log('%c New State:', 'color: green', store.getState());
      console.groupEnd();
    } else {
      next(action);
    }
  } catch (e) {
    console.error('reduxLogger', action, e);
    next(action);
  }
};
